// extracted by mini-css-extract-plugin
module.exports = {"component":"slide-in_component__DJi4U","curtain":"slide-in_curtain__OgCTS themeLightStrong"};